import { render, staticRenderFns } from "./TextAutocomplete.vue?vue&type=template&id=a8969420&scoped=true&"
import script from "./TextAutocomplete.vue?vue&type=script&lang=js&"
export * from "./TextAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8969420",
  null
  
)

export default component.exports